export default {
  "common": {
    "participate": "Participate now",
    "home": "Home",
    "contact": "Contact",
    "how_it_works": "How it works",
    "winners": "Winners",
    "good_cause": "Good cause",
    "account": "My account",
    "logout": "Logout"
  },
  "home": {
    "hero": {
      "grand_prize": "Grand prize of draw #52",
      "villa_title": "The villa that could change your life",
      "estimated_value": "Estimated value",
      "win_your": "Win your",
      "dream_house": "Dream House",
      "description": "A modern 500 m² villa valued at {{value}} up for grabs, plus dozens of exceptional prizes.",
      "buy_tickets": "Buy my tickets",
      "see_prizes": "See prizes",
      "prizes": {
        "title": "Over €1,200,000 in prizes to be won",
        "description": "A dream life awaits you. Try your luck today."
      }
    },
    "property": {
      "tabs": {
        "exterior": "Exterior",
        "interior": "Interior",
        "land": "Land"
      },
      "features": {
        "surface": "Surface",
        "bedrooms": "Bedrooms",
        "bathrooms": "Bathrooms",
        "pool": "Pool & Spa",
        "garden": "Garden",
        "garage": "Garage"
      }
    }
  },
  "admin": {
    "title": "Lottery Admin",
    "manage_lottery": "Manage lottery",
    "manage_packages": "Manage packages",
    "manage_prizes": "Manage prizes",
    "users": "Users",
    "settings": "Site settings"
  }
};
